import React, { useState } from "react";
import checkAnim from "../asset/checkAnim.gif";
import tickIcon from "../asset/check.JPG";
import "../style/hm3.css";
import "../style/promotion.css";
import enquiry from "../method/enquiry";
import { getImage } from "../module/api_init";
import crmEnquiry from "../method/lead";
import Qr_code from "../asset/QR_Code.png";
import { appStore, playStore } from "../module/logo";

function HomeonroadPrice2({ props }) {
  const [booked, setbooked] = useState(0);
  const [bike, setbike] = useState("");

  const { seasonCars, bannar_p } = props.state;

  const detail = [
    { name: "Book A Test Drive" },
    { name: "Book Car Evaluation" },
    { name: "Book A Home Visit" },
    { name: "Book A Showroom Visit" },
  ];
  return (
    <div className="center">
      <div
        className="hm3_Container2"
        style={{ backgroundImage: "url(" + getImage(bannar_p) + ")" }}
      >
        <div className="hm3_sf_d" style={{ width: "450px" }}>
          .
        </div>
        <div className="hm3_1_left-div">
          {booked === 0 ? (
            <>
              <div className="all1_hm_title">Enquiry</div>
              <div
                style={{
                  fontSize: 11,
                  color: "gray",
                  padding: "0px 10px",
                }}
              >
                Kindly fill your details to get desired services from Kalyani
                Motors sales expert.
              </div>
            </>
          ) : (
            <></>
          )}

          {booked !== 0 ? (
            booked === 1 ? (
              <img
                alt="Kalyani Motors Leading Maruti Suzuki Dealership"
                style={{ padding: "20px 103px", width: 100, display: "none" }}
                src={checkAnim}
              />
            ) : (
              <img
                alt="Kalyani Motors Leading Maruti Suzuki Dealership"
                style={{ padding: "20px 103px", width: 100, display: "none" }}
                src={tickIcon}
              />
            )
          ) : (
            <form
              id="booking_form1"
              onSubmit={async (e) => {
                if (e.target.id.value.length !== 10) {
                  alert("Not a valid phone number");
                  return;
                }
                setbooked(1);
                setbike(e.target.car.value);
                const body = {
                  name: e.target.name.value,
                  phone: e.target.id.value,
                  // email: "",
                  location: props.state.location.address,
                  // vehicle: e.target.car.value,
                  purpose: e.target.car.value,
                };
                const crmEnquiryBody = {
                  emailAddress: "",
                  crmSource: "KM Website",
                  creAgent: "",
                  "Phone Number": e.target.id.value,
                  Name: e.target.name.value,
                  "Email Address": "",
                  uniquePhone: true,
                  skill: "",
                  process: "KAM",
                  campaignId: "688c5d85d5e83faa10312c15",
                  campaignName: "Kalyani Motors",
                  agentId: "",
                  requestFrom: "website",
                  modelName: e.target.car.value,
                  purpose: "Enquiry",
                  location: props.state.location.address,
                  // variant:  e.target.car.value,
                  // channel: "Arena",
                  // crmSource: "Google Ads",
                  // leadType: "Website",
                  // isPrimary: "Yes",
                  // leadDate: new Date().toLocaleDateString(),
                  // transUniqueId: Math.floor(Math.random() * 10000),
                  // vehicle: e.target.car.value
                };
                // enquiry(body),
                await Promise.all([enquiry(body), crmEnquiry(crmEnquiryBody)]);
                //  setTimeout(() => {
                // 	 setbooked(0);
                //  }, 3000);
              }}
            >
              <input
                placeholder="Enter Your Name"
                className="hm3_input_tab"
                type="text"
                id="name"
                required
              />
              <input
                placeholder="Enter Your Phone Number"
                className="hm3_input_tab"
                type="text"
                id="id"
                required
              />
              {/* <select className="hm3_input_tab" id="car" required>
                {seasonCars.map((p) =>
                  p.bikes.map((bike, k) => (
                    <option value={bike.name} key={k}>
                      {bike.name}
                    </option>
                  ))
                )}
                <option>Others</option>
              </select> */}
              {
                <select className="hm3_input_tab" id="car" required>
                  <option value="Book A Test Drive">Book A Test Drive</option>
                  <option value="Book Car Evaluation">
                    Book Car Evaluation
                  </option>
                  <option value="Book A Home Visit">Book A Home Visit</option>
                  <option value="Book A Showroom Visit">
                    Book A Showroom Visit
                  </option>
                </select>
              }
              <button type="submit" className="hm3_btn">
                SUBMIT
              </button>
            </form>
          )}
          {booked !== 0 ? (
            <>
              <div className="promotion_container">
                <div className="promotion_content">
                  <p className="promotion_content_title">
                    Your Enquiry Was Sent Successfully!
                  </p>
                  <p className="promotion_content_desc">
                    Thank you for contacting us. we have received your enquiry
                    and will be in touch shortly
                  </p>
                  <hr className="line" />
                  <p className="promotion_content_desc2">
                    Stay connected with Super App
                  </p>
                  <p className="promotion_content_desc">
                    Track your requests, get instant updates, and explore
                    exclusive features right from your phone.
                  </p>
                </div>
                <div className="promotion_download">
                  <div className="promotion_download_content">
                    <div>
                      <img
                        src={Qr_code}
                        alt="QR code for app download"
                        className="promotion_qr"
                      />
                    </div>
                    <div className="promotion_buttons">
                      <img
                        width="150"
                        alt="Kalyanimotors Leading Maruti Suzuki Dealership"
                        src={playStore}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          (window.location =
                            "https://play.google.com/store/search?q=kalyani+motors+super+app")
                        }
                      />
                      <img
                        width="150"
                        alt="Kalyanimotors Leading Maruti Suzuki Dealership"
                        src={appStore}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          (window.location =
                            "https://apps.apple.com/in/app/kalyani-motors-app/id6479185557")
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                onClick={() =>
                  props.setState({ enquiryPopup: null }, setbooked(0))
                }
                className="pup1_a_h"
              >
                Close
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

export default HomeonroadPrice2;
